import { FormKitIcon } from "@formkit/vue";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("FormKitIcon", FormKitIcon);
});
